import gql from "graphql-tag";

export const GRAPHQL_INT_MAX = 2147483647; // GraphQL's int is signed 32-bit integer

/**
 * All the Relay connections require `first` or `last` param,
 * so you can use this constant to "get everything in a connection".
 */
export const ConnectionAllCount = GRAPHQL_INT_MAX;

export type RelayId = string;

export interface Edge<T> {
  readonly node: T;

  // Apollo client requires `__typename`, which should be filled by the client app code.
  readonly __typename?: string;
}

export interface Connection<T> {
  readonly edges: ReadonlyArray<Edge<T>>;
}

export interface ConnectionWithTotalCount<T> {
  readonly totalCount: number;
  readonly edges: ReadonlyArray<Edge<T>>;
}

export interface PageInfo {
  readonly startCursor: string | null;
  readonly endCursor: string | null;
  readonly hasNextPage: boolean;
  readonly hasPreviousPage: boolean;
}

export interface ConnectionWithPageInfo<T> {
  readonly pageInfo: PageInfo;
  readonly edges: ReadonlyArray<Edge<T>>;
}

export interface ConnectionWithNextPageInfo<T> {
  readonly pageInfo: {
    readonly endCursor: string | null;
    readonly hasNextPage: boolean;
  };
  readonly edges: ReadonlyArray<Edge<T>>;
}

export interface Nodes<T> {
  readonly nodes: ReadonlyArray<T>;
}

export const PageInfoFragmentName = "pageInfoFragment";

export const PageInfoFragment = gql`
fragment ${PageInfoFragmentName} on PageInfo {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
}
`;

const EMPTY_CONNECTION = {
  pageInfo: {
    hasNextPage: false,
    endCursor: null,

    hasPreviousPage: false,
    startCursor: null,
  },
  totalCount: 0,
  edges: [],
};

export function emptyConnection<T>(): Connection<T> {
  return EMPTY_CONNECTION;
}

export function emptyConnectionWithTotalCount<T>(): ConnectionWithTotalCount<T> {
  return EMPTY_CONNECTION;
}

export function emptyConnectionWithNextPageInfo<T>(): ConnectionWithNextPageInfo<T> {
  return EMPTY_CONNECTION;
}

export function connectionFromArray<T>(array: ReadonlyArray<T>): Connection<T> {
  return {
    edges: array.map((node) => ({ node })),
  };
}

export function arrayFromConnection<T>(connection: Connection<T>): ReadonlyArray<T> {
  return connection.edges.map((edge) => edge.node);
}
